import React from 'react';
import { classNames } from 'primereact/utils';
import { PrimeIcons } from 'primereact/api';

/** Says that the time slot is blocked. */
export const BlockedBanner = () => {
  return (
    <div className='cancellation-info warning'>
      <div className='warning-title'>
        <i className={classNames(PrimeIcons.LOCK, 'warning-icon')} />
        <span>Esta franja horaria está bloqueada</span>
      </div>
      <div className='cancellation-details'>
        <p>
          <strong>Este horario ha sido bloqueado por un administrador.</strong>
        </p>
        <p>No se pueden realizar reservas en este horario hasta que sea desbloqueado.</p>
      </div>
    </div>
  );
};
